import { BrazilDate } from "./BrazilDate";

/** Segunda-feira da semana da data (ISO yyyy-MM-dd), fuso São Paulo. */
export function mondayOfISO(dateIso: string): string {
  const date = BrazilDate.fromISOString(dateIso);
  const sp = BrazilDate.toSaoPaulo(date);
  const day = sp.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  sp.setDate(sp.getDate() + diff);
  return BrazilDate.formatISO(sp);
}

export function currentMondayISO(): string {
  return mondayOfISO(BrazilDate.todayISO());
}

/** Verifica se a data ISO cai em uma segunda-feira (fuso São Paulo). */
export function isMondayISO(dateIso: string): boolean {
  const sp = BrazilDate.toSaoPaulo(BrazilDate.fromISOString(dateIso));
  return sp.getDay() === 1;
}

export function isSegundaAtualISO(dateIso: string): boolean {
  return mondayOfISO(dateIso) === currentMondayISO();
}

export function isSegundaFuturaISO(dateIso: string): boolean {
  return mondayOfISO(dateIso) > currentMondayISO();
}

/** Última segunda-feira do mês civil da data (ISO yyyy-MM-dd). */
export function lastMondayOfMonthISO(
  dateIso: string = BrazilDate.todayISO()
): string {
  const [year, month] = dateIso.split("-").map(Number);
  const last = new Date(Date.UTC(year, month, 0));
  const lastIso = `${last.getUTCFullYear()}-${String(
    last.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(last.getUTCDate()).padStart(2, "0")}`;
  return mondayOfISO(lastIso);
}

/** Segunda-feira mínima para histórico (padrão ~2 anos). */
export function mondayMinHistoricoISO(semanasAtras = 104): string {
  const base = BrazilDate.fromISOString(currentMondayISO());
  const sp = BrazilDate.toSaoPaulo(base);
  sp.setDate(sp.getDate() - 7 * semanasAtras);
  return mondayOfISO(BrazilDate.formatISO(sp));
}

export function isMondayTodaySP(): boolean {
  return isoWeekdayTodaySP() === 1;
}

/** 1 = segunda … 7 = domingo (ISO, fuso São Paulo). */
export function isoWeekdayTodaySP(): number {
  const sp = BrazilDate.toSaoPaulo(BrazilDate.now());
  const d = sp.getDay();
  return d === 0 ? 7 : d;
}

/** Dia da semana (1–7) a partir de yyyy-MM-dd em São Paulo. */
export function isoWeekdayFromISO(dateIso: string): number {
  const sp = BrazilDate.toSaoPaulo(BrazilDate.fromISOString(dateIso));
  const d = sp.getDay();
  return d === 0 ? 7 : d;
}

export function labelDiaSemana(isoWeekday: number): string {
  return (
    DIAS_SEMANA_BASE.find((d) => d.valor === isoWeekday)?.label ??
    `Dia ${isoWeekday}`
  );
}

export function labelDiaSemanaCurto(isoWeekday: number): string {
  return (
    DIAS_SEMANA_BASE.find((d) => d.valor === isoWeekday)?.labelCurto ??
    String(isoWeekday)
  );
}

export function labelDiaSemanaFromISO(dateIso: string): string {
  return labelDiaSemana(isoWeekdayFromISO(dateIso));
}

export const DIAS_SEMANA_BASE = [
  { valor: 1, label: "Segunda-feira", labelCurto: "Seg" },
  { valor: 2, label: "Terça-feira", labelCurto: "Ter" },
  { valor: 3, label: "Quarta-feira", labelCurto: "Qua" },
  { valor: 4, label: "Quinta-feira", labelCurto: "Qui" },
  { valor: 5, label: "Sexta-feira", labelCurto: "Sex" },
  { valor: 6, label: "Sábado", labelCurto: "Sáb" },
  { valor: 7, label: "Domingo", labelCurto: "Dom" },
] as const;

export const DIA_SEMANA_DOMINGO = 7;

/** Colunas da base semanal (seg–dom). */
export const DIAS_SEMANA_COLUNAS_BASE = DIAS_SEMANA_BASE;

export function isDomingoDataFicha(dateIso: string): boolean {
  return isoWeekdayFromISO(dateIso) === DIA_SEMANA_DOMINGO;
}
